import React from "react";
import { ErrorBoundary } from "./ui/ErrorBoundary";
import { AuthProvider, useAuth } from "./ui/context/AuthContext";
import { Login } from "./ui/Login";
import { Shell } from "./ui/Shell";
import type { Session } from "./ui/auth";

// Bridge component to convert AuthContext user to Session format for Shell
function AppContent() {
  const { user, isAuthenticated, logout } = useAuth();
  const bootErr = (window as any).__BOOT_ERR__ as any;

  if (!isAuthenticated || !user) {
    return <Login bootErr={bootErr} />;
  }

  const session: Session = {
      username: user.email,
      role: user.role,
      displayName: user.displayName,
      loggedInAt: Date.now()
  };

  return (
    <Shell
      session={session}
      onLogout={() => logout()}
      bootErr={bootErr}
    />
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ErrorBoundary>
  );
}